import React,{useState,useEffect,useRef} from 'react'
import {useParams, useNavigate} from 'react-router-dom'
import EmailEditor, {  EmailEditorProps } from 'react-email-editor';
import templateService from '../../../services/template.service'
import {toast} from 'react-toastify'


function AddEmailTemplate() {
    const [templateTypes,setTemplateTypes] = useState([])
    const emailEditorRef = useRef(null);
    const [txtType, setTxtType] = useState("PREBOOKED_REMINDER");
    const [txtUsedBy, settxtUsedBy] = useState("CLINIC");
    const [txtSubject, setTxtSubject] = useState(null);
    const [jsonString,setJsonString] = useState(null);
    const navigate = useNavigate()

    const handletxtTypeChange = (event) => {
        setTxtType(event.target.value);
      };
     const handletxtUsedByChange = (event) => {
        settxtUsedBy(event.target.value);
      };
      const handleTextChange = (event) => {
        setTxtSubject(event.target.value);
      };


    const exportHtml = () => {
        emailEditorRef.current.editor.exportHtml((data) => {
          const { design, html } = data;
          const jsonString = JSON.stringify(design)
          const edata = {
            type: txtType,
            mediumType: "EMAIL",
            subjectLine : txtSubject,
            content: html,
            jsonContent : jsonString,
            usedBy: txtUsedBy,
          }
          //call api to save 
          templateService.saveEcxTemplate(1,edata)
          .then((res)=>{
            toast.success("Successfully Added New Template.", {
                position: toast.POSITION.BOTTOM_RIGHT,
              });
              navigate("/email-template");
          })
          .catch((err) => {
            toast.error("Cannot Create New Template.", {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            console.log(err);
          });
        });
      };
    
      const onLoad = () => {
         };
    
      const onReady = () => {
        // editor is ready
        //console.log('onReady');
      };
   
      useEffect(()=>{
            getTemplateTypes()
      },[])
      const getTemplateTypes = ()=>{
            templateService.getTemplateTypes()
            .then(res=>{
                setTemplateTypes(res.data)
            })
            .catch(err=>{
                console.log(err)
            })
      }
     
      function toProperCase(inputString) {
        // Split the string into words based on underscores
        let words = inputString.split('_');
    
        // Capitalize the first letter of each word and join them back
        let properCaseString = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
    
        return properCaseString;
    }
    const handleSave = ()=>{
        //things needed
        //type , mediumType="EMAIL", subjectLine, content, usedBy 
        
    }
    const handleCancel = ()=>{

    }
    return (
   <>  <div className="container container-xxl">
        <nav className="navbar mb-3 navbar-expand-lg rounded p-3" style={{backgroundColor:"#8b02ee"}}>
            <div className="container-fluid">
                        <div className="d-flex flex-column me-4">
                            <span className="navbar-brand" style={{color:"white"}}>Email Template</span>
                           
                        </div>
                      
                        <div className="d-flex flex-column">
                                <div className="row">
                                    <div className="col-4">
                                         <label htmlFor="" className='form-label' style={{color:"white"}}>Select Template</label>
                                    </div>
                                    <div className="col-8">
                                    <select name="" id="" className="form-select form-select-sm" onChange={handletxtTypeChange}>
                                        {templateTypes && templateTypes.map((item,index)=>{
                                            return   <option key={index} value={item}>{item}</option>
                                        })}
                                       
                                    </select>
                                    </div>
                                </div>
                               <div className="row mt-2">
                                        <div className="col-4">
                                          <label htmlFor="" className='form-label' style={{color:"white"}}>Used By</label>
                                        </div>
                                        <div className="col-8">
                                        <select name="" id="" onChange={handletxtUsedByChange} className="form-select form-select-sm">
                                     <option value="CLINIC" >Clinic</option>
                                     <option value="ECX">EyeconX</option>
                                       
                                    </select>
                                        </div>
                               </div>
                                <div className="row mt-2">
                                    <div className="col-3">
                                    <label htmlFor="" className="form-label me-2" style={{color:"white"}}>Subject</label>
                                    </div>
                                    <div className="col-9">
                                        <input type="text" minLength={3} onChange={handleTextChange} className="form-control form-control-sm" />
                                    </div>
                                </div>
                               
                            <div className="d-flex justify-content-between mt-2">
                              <button className="btn btn-sm btn-warning ms-2" onClick={exportHtml}>Save</button>
                             <button className="btn btn-sm btn-success ms-2">Cancel</button>
                            </div>
                          
                        </div>
                    
                    
              
               
            </div>
        </nav>
      
           
            <div className="row">
                <div className="col-12">
                <EmailEditor ref={emailEditorRef} onLoad={onLoad} onReady={onReady} style={{height:"80vh"}} />
                </div>
               
            </div>
        </div>
   </>
  )
}

export default AddEmailTemplate